import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "41",
  height: "41",
  fill: "none",
  viewBox: "0 0 41 41"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "36",
      height: "36",
      x: "2.519",
      y: "2.032",
      fill: "#2787F5",
      rx: "6"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M12.515 13.303h-2.48c-.708 0-.85.334-.85.701 0 .657.841 3.914 3.915 8.221 2.049 2.942 4.936 4.537 7.563 4.537 1.576 0 1.771-.355 1.771-.965v-2.223c0-.708.15-.85.649-.85.368 0 .998.184 2.47 1.602 1.68 1.681 1.958 2.436 2.903 2.436h2.48c.709 0 1.063-.355.859-1.053-.224-.697-1.027-1.708-2.092-2.906-.578-.683-1.445-1.418-1.708-1.786-.367-.473-.262-.683 0-1.103 0 0 3.022-4.255 3.337-5.7.157-.525 0-.91-.75-.91h-2.48c-.63 0-.921.333-1.079.7 0 0-1.26 3.073-3.047 5.07-.578.577-.84.761-1.156.761-.158 0-.386-.184-.386-.709v-4.911c0-.63-.183-.912-.708-.912h-3.897c-.394 0-.631.293-.631.57 0 .598.893.736.985 2.416v3.651c0 .8-.144.946-.46.946-.84 0-2.885-3.087-4.098-6.619-.238-.686-.476-.964-1.11-.964",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }